<script type="text/javascript">
  // general svelte objects
  import { onMount} from "svelte";
  import { writable } from "svelte/store";
  // Router & routes
  import Router from "svelte-spa-router";
  // import { push } from "svelte-spa-router";
  import { wrap } from "svelte-spa-router/wrap";

  // Routes aka Pages
  import Home from "./pages/Home.svelte";
  import About from "./pages/About.svelte";
  // import Aircraft from "./pages/Aircraft.svelte";
  // import Job from "./pages/Job.svelte";
  import NotFound from "./pages/NotFound.svelte";

  // Components
  import Navbar from "./components/Navbar.svelte";
  import Footer from "./components/Footer.svelte";

  // Scripts
  // import {getLatestFetchItem} from './scripts/appWrite/awFetcher';

  export let appName;
  export let AppWrite;

  const fetchItems = ""
  // const fetchItems = getLatestFetchItem(AppWrite)

  // const jobsCollection = writable()
  // const statsCollection = writable()
  // const jobsStats = writable()
  // const jobsDetails = writable()
  // const fetchError = writable()

  const selectedAircraft = ""
  // const selectedAircraft = writable('')

  // $: $fetchItems
  //     .then( (data) => {
  //       $jobsCollection = data.jobsCollection;
  //       $statsCollection = data.statsCollection;
  //     })
  //     .catch( (error) => {
  //       $fetchError = 'Error loading fetchItems: ' + error;
  //     })


  // ==========================================================================
  // all about our routes
  // ==========================================================================
  
  const routes = {
    // Home page
    "/": wrap({
      component: Home,
      props: { appName, AppWrite, fetchItems, selectedAircraft},
    }),

    // Aircraft page
    // "/aircraft/": wrap({
    //   component: Aircraft,
    //   props: { AppWrite, selectedAircraft, jobsCollection},
    // }),

    // Jobs page
    // "/job/:reg": wrap({
    //   component: Job,
    //   props: { AppWrite, selectedAircraft, jobsCollection},
    // }),

    // About page
    "/about/": About,

    // Catch-all
    "*": NotFound,
  };


</script>

<svelte:head>
  <style src="../bulma-base.scss">
  </style>
  <!-- <script data-name="BMC-Widget" data-cfasync="false" src="https://cdnjs.buymeacoffee.com/1.0.0/widget.prod.min.js" data-id="cellerich" data-description="Support me on Buy me a coffee!" data-message="If you like this site, you might buy me a beer 😎" data-color="#5F7FFF" data-position="Right" data-x_margin="18" data-y_margin="18"></script>   -->
</svelte:head>


<Navbar />
<section class="hero is-primary is-fullheight">
  <div class="mt-16 mx-12">
    <Router {routes} />
  </div>

  <div class="hero-foot">
    <Footer />
  </div>
</section>

<style lang="scss">
  @import "../node_modules/bulma/sass/utilities/_all.sass";

  h1 {
    color: $primary;
  }
  p {
    color: $danger;
  }
</style>


